export default {
  render (h) {
    return h('router-view')
  }
}



// WEBPACK FOOTER //
// ./src/router/RouteDelegate.js